import {Injector, Input, OnInit, Directive} from '@angular/core';

import {FilterCategory} from "../../../../services/model/filterCategory";
import {CacheService} from "../../../../services/sys/cache.service";
import {FilterManagerService} from "../../../../services/ui/filter-manager.service";
import {QueryManagerService} from "../../../../services/domain/query-manager.service";
import {StaticsService} from "../../../../services/sys/statics.service";
import {Observable, Subscription} from "rxjs";
import {FilterValue} from "../../../../services/model/filterValue";
import {ModalService} from "../../../../services/ui/modal.service";
import {ApplicationService} from "../../../../services/domain/application.service";
import {Bucket} from "../../../../services/model/bucket";
import {QueryValue} from "../../../../services/model/queryValue";

@Directive()
export abstract class EfastFilterBaseComponent implements OnInit {

    @Input() events: Observable<void>;

    filterCategory: FilterCategory = new FilterCategory();
    protected cacheService: CacheService;
    protected filterManagerService: FilterManagerService;
    protected queryManagerService: QueryManagerService;
    protected staticsService: StaticsService;
    protected modalService: ModalService;
    protected applicationService: ApplicationService

    protected eventsSubscription: Subscription;
    protected queryValue: QueryValue;
    title: string;
    protected bucket: Bucket[];

    constructor(injector: Injector) {
        this.cacheService = injector.get(CacheService);
        this.filterManagerService = injector.get(FilterManagerService);
        this.queryManagerService = injector.get(QueryManagerService);
        this.staticsService = injector.get(StaticsService);
        this.modalService = injector.get(ModalService);
        this.applicationService = injector.get(ApplicationService);
    }

    protected addFilterValue(displayValue: string, value: string, isIndividual: boolean = true): FilterValue {
        let filterValue = new FilterValue();

        filterValue.displayValue = displayValue;
        filterValue.value = value;
        filterValue.isIndividual = isIndividual;

        return filterValue;
    }

    protected setBucket(bucket: Bucket[]) {
        this.bucket = bucket;
    }

    protected expandClick() {
        if (this.filterCategory.isExpanded) {
            this.filterCategory.isExpanded = false;
        }
        else {
            this.filterCategory.isExpanded = true;
        }

        this.filterManagerService.updateFilterCategory(this.filterCategory);
     }

    ngOnInit() {
        this.eventsSubscription = this.events.subscribe(() => this.searchChangeEvent());
        this.filterManagerService.addFilterCategory(this.filterCategory);
        this.filterCategory = this.filterManagerService.getFilterCategory(this.filterCategory) ?? this.filterCategory;
        this.searchChangeEvent();
    }

    ngOnDestroy() {
        this.eventsSubscription.unsubscribe();
    }

    protected cleanField(val:string) : string {
        val = val.replace(/\$/g, "");
        val = val.replace(/,/g, "");

        return val;
    }

    protected cleanFieldNoPeriod(val:string) : string {
        val = val.replace(/\$/g, "");
        val = val.replace(/,/g, "");

        return val;
    }

    protected rowClick(filterValue: FilterValue, forceDisplayValue: boolean = false) {
        this.queryValue = new QueryValue();

        this.queryValue.value = filterValue.value.trim();
        let displayValue: string;
        if (filterValue.isIndividual && !forceDisplayValue) {
            displayValue = filterValue.value.trim();
        }
        else {
            displayValue = filterValue.displayValue.trim().replace(":","");
        }

        this.queryValue.displayValue = displayValue;

    }

    protected searchChangeEvent() {

        this.resetFilterCount();

        if (this.bucket != null) {
            let facets: Bucket[] = this.bucket;
            for (let facet of facets) {
                if (this.filterCategory.filterType == this.staticsService.getFilterType().ASSETS) {
                    this.filterCategory.filterValues.map(function (e) {
                        return e.value;
                    });
                }
                let idx: number= -1;
                if (this.filterCategory.filterType == this.staticsService.getFilterType().BUSINESS) {
                    if (facet.value.length > 2) {
                        facet.value = facet.value.substring(0,2);
                    }
                }
                idx = this.filterCategory.filterValues.map(function(e) { return e.value; }).indexOf(facet.value);
                if (idx != -1) {
                    this.filterCategory.filterValues[idx].count = facet.count.toString();
                }

            }
        }

    }

    protected resetFilterCount() {
        let newFilterValues: FilterValue[] = new Array();

        if (this.filterCategory.filterValues != undefined) {
            for (let filterValue of this.filterCategory.filterValues) {
                filterValue.count = "0";
                newFilterValues.push(filterValue);
            }
            this.filterCategory.filterValues = newFilterValues;
        }
    }
}